import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { withPortalProviders } from 'modules/utils';
import { CancelToken, isCancel } from 'axios';
import { queryContests } from 'services/requests';
import cleanDeep from 'clean-deep';
import queryString from 'query-string';
import { Contests as ContestsPortal } from '@uaveiro/ui';

const Contests = ({
  contestType,
  states,
  tabs,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [contests, setContests] = useState([]);
  const [contestsFiltered, setContestsFiltered] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [error, setError] = useState(null);
  const { lang } = useParams()

  const getContests = async () => {
    try {
      const dirty = {
        type: contestType, state: states, language: lang
      };
      const params = cleanDeep(dirty);
      const query = queryString.stringify(params);
      setError(null);
      setLoading(true);
      const response = await queryContests(query);
      const filteredContests = response.data.data.filter(contest => {
        const hasOpenApplications = contest.openApplications;
        const isAdmissionState = contest.contestStateId === 2;
        const [day, month, year] = contest.submissionDeadlineFormattedDate.split('-');
        const submissionDeadline = new Date(year, month - 1, day);
        const isSubmissionDeadlineExpired = submissionDeadline < new Date();
        // Não mostra concursos em estado admissão que estejam expirados ou que não tenham candidaturas abertas
        return !(isAdmissionState && (!hasOpenApplications || isSubmissionDeadlineExpired));
      });
      setContests(filteredContests);
      setLoading(false)
    } catch (err) {
      const cancelled = isCancel(err);
      if (!cancelled) {
        setContests([])
        setLoading(false);
        setError(err);
      }
    }
  }

  useEffect(() => {
    const source = CancelToken.source();
    if (tabs.length > 0) {
      setActiveTab(tabs[0].id)
    }
    getContests();
    return () => {
      // cleanup function that cancels pending requests
      source.cancel();
    };
  }, [contestType, JSON.stringify(states), JSON.stringify(tabs), lang]);

  useEffect(() => {
    if (activeTab !== null && states.length > 0) {
      setContestsFiltered(contests.filter((contest) => contest.contestStateId === activeTab));
    } else {
      setContestsFiltered(contests);
    }
  }, [contests, activeTab]);

  const onChangeTab = id => {
    setActiveTab(id);
  };

  return withPortalProviders(ContestsPortal, {
    ...props, hasError: error, loading, onChangeTab, activeTab, tabs, data: { contests: contestsFiltered }
  });
};

export default Contests;
